import { Model } from "@bryntum/core-thin";

export class PeriodicModel extends Model {
  static get fields() {
    return [{ name: "_grandTotal", defaultValue: 0 }];
  }
}
